import { render, staticRenderFns } from "./ConsultingLong.vue?vue&type=template&id=474f2207"
import script from "./ConsultingLong.vue?vue&type=script&lang=js"
export * from "./ConsultingLong.vue?vue&type=script&lang=js"
import style0 from "./ConsultingLong.vue?vue&type=style&index=0&id=474f2207&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports